<template>
  <div class="contactCard">
    <font-awesome-icon v-if="faIcon"
                       aria-hidden="true"
                       class="contactCard__icon"
                       :icon="faIcon">
    </font-awesome-icon>
    <h4 class="contactCard__title">
      {{ title }}
    </h4>
    <p class="contactCard__info">
      {{ info }}
    </p>
    <a
      v-for="(item, index) in contactInfo"
      :key="index"
      :class="[
        'contactCard__action',
        'btn',
        { 'btn-accent-1': index % 2 === 0, 'btn-accent-2': index % 2 !== 0 },
      ]"
      :href="item.href">
      <div class="contactCard__action__label">
        <font-awesome-icon
          aria-hidden="true"
          :icon="contact.icon[item.type]"
          class="align-content-center h-100 mr-2">
        </font-awesome-icon>
        <div
          :class="[
            'contactCard__action__text',
            {
              'contactCard__action__text--small': item.label.length > 30 && item.label.length < 34,
              'contactCard__action__text--smallest': item.label.length >= 34,
            },
          ]">
          {{ item.label }}
        </div>
      </div>

      <font-awesome-icon
        aria-hidden="true"
        class="align-content-center h-100"
        icon="chevron-right"></font-awesome-icon>
    </a>
  </div>
</template>
<script>
const CONTACT_TYPE = {
  EMAIL: "CONTACT_EMAIL",
  PHONE: "CONTACT_PHONE",
};

export default {
  name: "ContactCard",
  props: {
    faIcon: {
      type: Array,
      default: () => undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    info: {
      type: String,
      default: undefined,
    },
    contacts: {
      type: Array,
      required: true,
      validator: val => {
        const schema = ["type", "data"];
        return val.every( obj => schema.every( key => key in obj ) );
      },
    },
  },
  data () {
    return {
      CONTACT_TYPE,
      contact: {
        prefix: {
          [CONTACT_TYPE.PHONE]: "tel:",
          [CONTACT_TYPE.EMAIL]: "mailto:",
        },
        icon: {
          [CONTACT_TYPE.PHONE]: ["fal", "mobile-android-alt"],
          [CONTACT_TYPE.EMAIL]: ["fal", "envelope"],
        },
      },
    };
  },
  computed: {
    contactInfo () {
      return this.contacts
        .map( c => {
          const { type, data } = c;
          let mutableContact = null;

          if ( this.objectHasValue( this.CONTACT_TYPE, type ) && this.hasValue( data ) ) {
            mutableContact = {
              type,
              href: `${this.contact.prefix[type]}${data}`,
              label: data,
            };
          }
          return mutableContact;
        } )
        .filter( info => info != null );
    },
  },
  methods: {
    createContactActionLink ( item ) {
      const { type, data } = item;
      let action;
      if ( this.isNullOrEmpty( type ) || this.isNullOrEmpty( data ) ) {
        action = "#";
      } else if ( type === CONTACT_TYPE.PHONE ) {
        action = `tel: ${data}`;
      } else if ( type === CONTACT_TYPE.EMAIL ) {
        action = `mailto: ${data}`;
      } else {
        action = "#";
      }

      return action;
    },
    objectHasValue ( obj, val ) {
      return Object.values( obj ).indexOf( val ) > -1;
    },
    hasValue ( val ) {
      return this.isNullOrEmpty( val ) === false;
    },
    isNullOrEmpty ( val ) {
      return val == null || val === "";
    },
  },
};
</script>
<style lang="less" scoped>
@crimson: #d61921;
@contactPadding: 8px;
@contactHeight: 48px;

.contactCard {
  width: 360px;
  display: flex;
  flex-flow: column;

  &__icon {
    color: @crimson;
    width: 69px;
    height: 69px;
    margin: 0 0 20px;
  }

  &__title {
    margin: 0 0 32px;
  }

  &__info {
    margin: 0 0 16px;
    flex: 1 1 auto;
  }

  &__action {
    min-width: 300px;
    margin: 0 0 16px;
    justify-content: space-between;

    &__label {
      align-items: center;
      display: flex;
    }

    &__text {
      text-align: left;
      white-space: nowrap;

      &--small {
        font-size: 0.9rem;
      }

      &--smallest {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
